import { IS_LOADING, ERROR} from "../../constants";

export { IS_LOADING, ERROR }

export const GET_LOGGED_EMPLOYEE = "GET_LOGGED_EMPLOYEE"
export const CHANGE_PROFILE_MODAL_STATE = "CHANGE_PROFILE_MODAL_STATE";
